<template>
  <div class="input-container-333">
    <input
      type="text"
      placeholder="Enter Title..."
      class="title-input"
      v-model="title"
      @input="$emit('update:title', title)"
    />
    <input
      type="number"
      placeholder="Indicate the total duration of this lesson, in minutes..."
      class="duration-input"
      v-model.number="duration"
      @input="$emit('update:duration', duration)"
    />
    <input
      type="text"
      placeholder="Enter Sub Title...(Max 150 Characters)"
      class="subtitle-input"
      v-model="subtitle"
      @input="$emit('update:subtitle', subtitle)"
      maxlength="150"
    />
  </div>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from "vue";

const title = ref("");
const subtitle = ref("");
const duration = ref(null);

defineEmits(["update:title", "update:subtitle", "update:duration"]);

// Method to update from parent
const updateFromParent = (newTitle, newSubtitle, newDuration) => {
  title.value = newTitle;
  subtitle.value = newSubtitle;
  duration.value = newDuration;
};

// Expose method to parent
defineExpose({
  updateFromParent,
});
</script>

<style scoped>
.input-container-333 {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 20px;
  margin: auto;
}

input {
  width: 100%;
  border: none;
  outline: none;
  padding: 10px;
  margin: 5px 0;
  font-size: 1.2em;
  color: #333;
}

input.title-input {
  font-size: 2em;
  font-weight: bold;
}

input.duration-input {
  font-size: 1em;
  color: #666;
}

input.subtitle-input {
  font-size: 1em;
  color: #666;
}
</style>
